import { useSEO, type SEOConfig } from '@/hooks/useSEO'

/**
 * SEO 메타 태그를 설정하는 컴포넌트
 * 라우트 설정에서 자동으로 렌더링됨
 */
export default function SEO({ title, description, noindex = false, structuredData }: SEOConfig) {
  useSEO({ title, description, noindex, structuredData })
  return null
}

// 타입 re-export (route-definitions.tsx에서 사용)
export type { SEOConfig }
